import * as THREE from 'three';

export class Formation{

    constructor(){

    }

    public static getPoint(
        index:number,
        numX:number,//xz方向の個数
        numY:number,//y方向の個数
        amp:number,
        offsetRad:number
    ):THREE.Vector3{

        let spaceY = 0.4;

        let i = index % numX;
        let j = Math.floor( index/numX );

        let yy:number = j*spaceY - (numY-1)/2*spaceY;
  
        let rad = i/(numX) * Math.PI * 2 + Math.PI/2 + offsetRad;

        //if(j==0)console.log(i+":"+rad+":"+numX);

        let xx:number = amp * Math.cos(rad);
        let zz:number = amp * Math.sin(rad);

        return new THREE.Vector3(xx,yy,zz);

    }


}